// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Amatic+SC:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Architects+Daughter&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Caveat:wght@400..700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gloria+Hallelujah&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Patrick+Hand&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alegreya+SC&family=Alegreya+Sans+SC&family=Bad+Script&family=Carrois+Gothic+SC&family=Clicker+Script&family=Cormorant+SC&family=Dancing+Script&family=Dr+Sugiyama&family=Gloria+Hallelujah&family=Grand+Hotel&family=Josefin+Sans&family=Lily+Script+One&family=Pacifico&family=Permanent+Marker&family=Reenie+Beanie&family=Righteous&family=Satisfy&family=Seaweed+Script&family=Shadows+Into+Light&family=Vibes&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-alegreya {
	font-family: 'Alegreya SC', serif;
}

.font-alegreyasans {
	font-family: 'Alegreya Sans SC', sans-serif;
}

.font-amatic {
	font-family: 'Amatic SC', cursive;
}

.font-architects {
	font-family: 'Architects Daughter', cursive;
}

.font-badscript {
	font-family: 'Bad Script', cursive;
}

.font-carrois-gothic-sc {
	font-family: 'Carrois Gothic SC', sans-serif;
}

.font-caveat {
	font-family: 'Caveat', cursive;
}

.font-clickerscript {
	font-family: 'Clicker Script', cursive;
}

.font-cormorant {
	font-family: 'Cormorant SC', serif;
}

.font-dancingScript {
	font-family: 'Dancing Script', cursive;
}

.font-dr-sugiyama {
	font-family: 'Dr Sugiyama', cursive;
}

.font-gloria {
	font-family: 'Gloria Hallelujah', cursive;
}

.font-grand-hotel {
	font-family: 'Grand Hotel', cursive;
}

.font-indie {
	font-family: 'Indie Flower', cursive;
}

.font-josefin-sans {
	font-family: 'Josefin Sans', sans-serif;
}

.font-lily-script-one {
	font-family: 'Lily Script One', cursive;
}

.font-marker {
	font-family: 'Permanent Marker', cursive;
}

.font-pacifico {
	font-family: 'Pacifico', cursive;
}

.font-patrick {
	font-family: 'Patrick Hand', cursive;
}

.font-playfair {
	font-family: 'Playfair Display', serif;
}

.font-reenie-beanie {
	font-family: 'Reenie Beanie', cursive;
}

.font-righteous {
	font-family: 'Righteous', sans-serif;
}

.font-robotoslab {
	font-family: 'Roboto Slab', serif;
}

.font-satisfy {
	font-family: 'Satisfy', cursive;
}

.font-seaweed-script {
	font-family: 'Seaweed Script', cursive;
}

.font-shadows-into-light {
	font-family: 'Shadows Into Light', cursive;
}

.font-vibes {
	font-family: 'Vibes', cursive;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/font.css"],"names":[],"mappings":"AAWA;CACC,iCAAiC;AAClC;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,6BAA6B;AAC9B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Amatic+SC:wght@400;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Architects+Daughter&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Caveat:wght@400..700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Gloria+Hallelujah&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Patrick+Hand&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Alegreya+SC&family=Alegreya+Sans+SC&family=Bad+Script&family=Carrois+Gothic+SC&family=Clicker+Script&family=Cormorant+SC&family=Dancing+Script&family=Dr+Sugiyama&family=Gloria+Hallelujah&family=Grand+Hotel&family=Josefin+Sans&family=Lily+Script+One&family=Pacifico&family=Permanent+Marker&family=Reenie+Beanie&family=Righteous&family=Satisfy&family=Seaweed+Script&family=Shadows+Into+Light&family=Vibes&display=swap');\n\n.font-alegreya {\n\tfont-family: 'Alegreya SC', serif;\n}\n\n.font-alegreyasans {\n\tfont-family: 'Alegreya Sans SC', sans-serif;\n}\n\n.font-amatic {\n\tfont-family: 'Amatic SC', cursive;\n}\n\n.font-architects {\n\tfont-family: 'Architects Daughter', cursive;\n}\n\n.font-badscript {\n\tfont-family: 'Bad Script', cursive;\n}\n\n.font-carrois-gothic-sc {\n\tfont-family: 'Carrois Gothic SC', sans-serif;\n}\n\n.font-caveat {\n\tfont-family: 'Caveat', cursive;\n}\n\n.font-clickerscript {\n\tfont-family: 'Clicker Script', cursive;\n}\n\n.font-cormorant {\n\tfont-family: 'Cormorant SC', serif;\n}\n\n.font-dancingScript {\n\tfont-family: 'Dancing Script', cursive;\n}\n\n.font-dr-sugiyama {\n\tfont-family: 'Dr Sugiyama', cursive;\n}\n\n.font-gloria {\n\tfont-family: 'Gloria Hallelujah', cursive;\n}\n\n.font-grand-hotel {\n\tfont-family: 'Grand Hotel', cursive;\n}\n\n.font-indie {\n\tfont-family: 'Indie Flower', cursive;\n}\n\n.font-josefin-sans {\n\tfont-family: 'Josefin Sans', sans-serif;\n}\n\n.font-lily-script-one {\n\tfont-family: 'Lily Script One', cursive;\n}\n\n.font-marker {\n\tfont-family: 'Permanent Marker', cursive;\n}\n\n.font-pacifico {\n\tfont-family: 'Pacifico', cursive;\n}\n\n.font-patrick {\n\tfont-family: 'Patrick Hand', cursive;\n}\n\n.font-playfair {\n\tfont-family: 'Playfair Display', serif;\n}\n\n.font-reenie-beanie {\n\tfont-family: 'Reenie Beanie', cursive;\n}\n\n.font-righteous {\n\tfont-family: 'Righteous', sans-serif;\n}\n\n.font-robotoslab {\n\tfont-family: 'Roboto Slab', serif;\n}\n\n.font-satisfy {\n\tfont-family: 'Satisfy', cursive;\n}\n\n.font-seaweed-script {\n\tfont-family: 'Seaweed Script', cursive;\n}\n\n.font-shadows-into-light {\n\tfont-family: 'Shadows Into Light', cursive;\n}\n\n.font-vibes {\n\tfont-family: 'Vibes', cursive;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
